import { useMemo } from 'react'
// import { getUserInfoHttp, getUserExtendInfoHttp } from 'src/fetch/user'
import { UserInfoHS } from 'src/commons/store/UserStore'

/**
 * 
 * 获取登录状态 和 用户信息
 * @return {isLogin} 当前用户是否登录
 * @return {vipDate} 当前用户的用户信息
 * @return {userExtendInfo} 当前用户的扩展信息
 */
const useIsLogin = () => {
  const [userInfo] = useMemo(() => {
    const userInfo = UserInfoHS.SuccessResult
    return [userInfo]
  }, [UserInfoHS.SuccessResult])

  const isLogin = !!userInfo

  return {isLogin, userInfo}
}

export default useIsLogin